export default {
  type: 'array',
  minItems: 4,
  items: {
    type: 'number'
  }
};
